// TODO: Get this from the email microservice (or an SDK const?) instead
export const DEFAULT_SENDER_DOMAIN = 'smblogin.com';
